import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// graphQL
import gql from 'graphql-tag';
// our components
import StatsPeriod from 'components/common/StatsPeriod/StatsPeriod';
import Metrics from 'components/common/Metrics/Metrics';

export const REVIEWED_ADS_METRIC_QUERY = gql`
  query reviewedAdsMetric($minDate: Date!, $maxDate: Date!) {
    reviewedAdsStats(minDate: $minDate, maxDate: $maxDate) {
      plot {
        date
        value
      }
    }
  }
`;

const AdMetricsContainer = ({ t }) => (
  <StatsPeriod query={REVIEWED_ADS_METRIC_QUERY} defaultLast="week">
    {({ data, updateData }) => (
      <Metrics
        title={t('dashboard.reviewed_ads')}
        color="success"
        type="Line"
        data={data && data.reviewedAdsStats ? data.reviewedAdsStats.plot : []}
        statsUpdate={date => updateData(date)}
      />
    )}
  </StatsPeriod>
);

AdMetricsContainer.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AdMetricsContainer);
